import {createContext, useContext} from 'react';
import PropTypes from 'prop-types';

/**
 * `true`: Shop the Look is nested (blog tile, carousel, section panel, CF-07, …) — flush outer chrome.
 * `false` (default): outer chrome from data — `ShopTheLook` uses `standaloneContent` only when
 * `hotspotsContentCollection` is linked; productId-only JSON hotspots stay flush.
 */
export const ShopTheLookEmbedContext = createContext(false);

/** Marks descendants as embedded Shop the Look (flush theme). */
export function ShopTheLookEmbedProvider({children}) {
  return <ShopTheLookEmbedContext.Provider value={true}>{children}</ShopTheLookEmbedContext.Provider>;
}

ShopTheLookEmbedProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

/** @returns {boolean} */
export function useShopTheLookIsEmbedded() {
  return useContext(ShopTheLookEmbedContext);
}
